import React from 'react';
import PageHeader from '../../components/base/PageHeader';
import CLIFilters from './CLIFilters';
import CLITable from './CLITable';
import {LOCAL_STORAGE_CLI_FILTERS_DIALER} from '../../const';
import {injectIntl} from "react-intl";
import {Spacer} from '../../components/base/Spacer';
import {Toggle} from 'rsuite';
import m from "../../definedMessages";
import PanelLayout from "../../components/base/PanelLayout";
import {BaseToggle} from "../../components/base/BaseToggle";

class CLI extends React.Component {
    constructor(props) {
        super(props);
        
        const {account} = props.account.session || {};
        const savedTableFilter = JSON.parse(localStorage.getItem(LOCAL_STORAGE_CLI_FILTERS_DIALER));
        
        this.isTest = account.hasOwnProperty('is_test') ? account.is_test : false;
        this.formatMessage = props.intl.formatMessage.bind(props.intl);

        this.state = {
            filter: {
                ...(savedTableFilter || {})
            },
            isAuth: false,
            searchLoading: false,
            resizedWidth: window.innerWidth
        };
    }


    componentDidMount() {
        const {filter, isAuth} = this.state;
        const {getCLIList} = this.props;

        if (filter && filter.str) 
            getCLIList(filter, isAuth);

        window.addEventListener('resize', this.handleResize);
    }


    componentDidUpdate(prevProps, prevState) {
        const {filter, isAuth} = this.state;
        const {getCLIList} = this.props;
        if (isAuth !== prevState.isAuth && filter.str) {
            getCLIList(filter, isAuth);
        }
    }


    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }


    onChangeFilters = (filtersObj) => {
        const {isAuth} = this.state;
        const {getCLIList} = this.props;

        localStorage.setItem(LOCAL_STORAGE_CLI_FILTERS_DIALER, JSON.stringify(filtersObj));
        this.setState({
            filter: {...filtersObj}
        });

        getCLIList(filtersObj, isAuth);
    };


    changeTab = (value) => {
        this.setState({isAuth: value});
    }


    handleResize = () => {
        this.setState({resizedWidth: window.innerWidth})
    };


    render() {
        const {searchLoading, filter, isAuth} = this.state;
        const {CLIList, CLILoading, count} = this.props;

        const onChangeFilters = this.onChangeFilters;

        return (
            <PanelLayout>
                <PageHeader title={this.formatMessage(m.cliLookup)}/>
                
                <BaseToggle
                    size="lg"
                    unCheckedChildren={this.formatMessage(m.dialerTraffic)}
                    checkedChildren="OTP"
                    defaultChecked={isAuth}
                    onChange={value => this.changeTab(value)}
                />
                
                <Spacer size={30}/>
                
                <CLIFilters
                    onChangeFilter={onChangeFilters}
                    loading={CLILoading || searchLoading}
                    savedTableFilter={filter}
                />
                
                <Spacer/>
                
                <CLITable
                    spAuth={isAuth}
                    data={CLIList} 
                    loading={CLILoading || searchLoading} 
                    count={count}
                />
            </PanelLayout>
        );

    }

}

export default injectIntl(CLI)